<template>
  <v-container v-if="this.user != ''">
    <!-- <v-card class="mx-auto red">
        <v-card-title>Add Users To Notice</v-card-title>
        <v-text-field
            v-model="noticeId"
            @change="getNotice()"
            dense
            filled
            label="notice"
          ></v-text-field>
          <v-row><v-col class = "mx-2" cols="11">
            {{ noticeDescription.noticeTitle }}
            </v-col><v-col class = "mx-2" cols="11">
            {{ noticeDescription.noticeDescription }}
          </v-col><v-col class = "mx-2" cols="11">
            {{ noticeDescription.noticeLink }}
          </v-col></v-row>

        <v-btn
              class="mx-4 my-5"
              dark
              @click="addDeviceOwnersToNotice()"
              >Add Device Owners
            </v-btn>
      </v-card> -->

    <v-card color="rgb(0, 255, 200, 0.6)">
      <v-card-title
        >Past Week
        <v-spacer></v-spacer>
        <!-- Refresh Button -->
        <v-btn
          icon
          v-tooltip.bottom-start="'Refresh'"
          @click="refreshDeviceHistory()"
        >
          <v-icon>mdi-refresh</v-icon>
        </v-btn></v-card-title
      >

      <v-data-table
        dense
        :headers="historyHeaders"
        :items="deviceHistory"
        class="elevation-1"
        sort-by="createdAt"
        sort-desc
        @click:row="handleHistoryClick"
      >
      </v-data-table>
    </v-card>

    <v-card dark class="mx-auto" color="rgb(80, 80, 80, 0.6)">
      <v-card-title>Haikubox Admin</v-card-title>
      <v-row class="px-4"
        ><v-col cols="8">
          <v-autocomplete
            :items="haikuboxList"
            label="Select Haikubox"
            v-model="haikubox"
            @change="selectHaikubox(haikubox)"
            auto-select-first
          ></v-autocomplete
        ></v-col>
        <v-col cols="4">
          <v-btn class="my-5" dark @click="getHaikuboxList()"
            >Reset
          </v-btn></v-col
        ></v-row
      >
      <v-row class="px-4"
        ><v-col cols="8">
          <v-autocomplete
            v-model="email"
            :items="usersList"
            :search-input.sync="getUsersByEmail"
            @change="getDevicesByOwner()"
            dense
            filled
            label="email"
          ></v-autocomplete>
          <v-card-text>Email: {{ email }}</v-card-text>
          <v-card-text v-if="confirmedEmail"
            >Account confirmed: Yes</v-card-text
          >
          <v-card-text v-if="confirmedEmail === false"
            >Account confirmed: No</v-card-text
          >
          <v-card-text
            >Account last updated: {{ accountUpdatedAt }} ET</v-card-text
          >
          <v-card-text>Number of Haikuboxes: {{ numHaikuboxes }}</v-card-text>
          <v-card-text
            >One Signal Consent for Notifications Granted:
            {{ oneSignalConsentGranted }}</v-card-text
          >
        </v-col>
      </v-row>
      <v-data-table
        dense
        :headers="haikuboxHeaders"
        :items="haikuboxProps"
        class="elevation-1"
        @click:row="handleHistoryClick"
      >
      </v-data-table>
      <v-data-table
        dense
        :headers="subscriptionHeaders"
        :items="subscriptionProps"
        class="elevation-1"
      >
      </v-data-table>
    </v-card>
    <v-card class="mx-auto pa-10" outlined>
      <v-app-bar dark color="blue">
        {{ haikubox }}
        <v-spacer></v-spacer>
      </v-app-bar>
      <v-card-subtitle>v{{ firmwareVersion }} </v-card-subtitle>
      <v-img height="100%" width="100%" v-if="lat != 0">
        <l-map
          :center="[lat, lon]"
          style="height: 400px; width: 100%"
          :zoomControl="false"
          :zoom="7"
        >
          <l-tile-layer :url="urlStates" :attribution="attributionSummary" />
          <l-marker :lat-lng="[lat, lon]" /> </l-map
      ></v-img>

      Boot History
      <v-list dense v-for="item in bootTable" :key="item.id">
        <v-list-item> v{{ item.version }}: {{ item.createdAt }}</v-list-item>
      </v-list>

      <div class="mx-auto pa-12">
        <line-chart
          :colors="['#fcba03']"
          :height="150"
          ytitle="CPU Temp"
          :library="{
            scales: {
              xAxes: [
                {
                  type: 'time', time: { unit: 'hour', displayFormats: { hour: 'MMM DD HH:mm' } },
                  ticks: {
                    fontColor: '#000000',
                  },
                },
              ],
              yAxes: [
                {
                  ticks: {
                    fontColor: '#000000',
                  },
                },
              ],
            },
          }"
          :data="cpuTempSeries"
        ></line-chart>
        <!-- <column-chart
          :colors="['#fcba03']"
          :height="150"
          :min="0"
          :max="2"
          ytitle="CPU GHz"
          :library="{
            scales: {
              xAxes: [
                {
                  ticks: {
                    fontColor: '#000000',
                  },
                },
              ],
              yAxes: [
                {
                  ticks: {
                    fontColor: '#000000',
                  },
                },
              ],
            },
          }"
          :data="cpuFreqSeries"
        ></column-chart> -->
        <!-- <column-chart
          :colors="['#fcba03']"
          :height="150"
          :min="0"
          ytitle="ramdisk"
          :library="{
            scales: {
              xAxes: [
                {
                  ticks: {
                    fontColor: '#000000',
                  },
                },
              ],
              yAxes: [
                {
                  ticks: {
                    fontColor: '#000000',
                  },
                },
              ],
            },
          }"
          :data="ramdiskSeries"
        ></column-chart> -->
        <line-chart
          :colors="['#fcba03']"
          :height="150"
          ytitle="WiFi dBm"
          :library="{
            scales: {
              xAxes: [
                {
                  type: 'time', time: { unit: 'hour', displayFormats: { hour: 'MMM DD HH:mm' } },
                  ticks: {
                    fontColor: '#000000',
                  },
                },
              ],
              yAxes: [
                {
                  ticks: {
                    fontColor: '#000000',
                  },
                },
              ],
            },
          }"
          :data="signalSeries"
        ></line-chart>
        <line-chart
          :colors="['#fcba03']"
          :height="150"
          ytitle="# Direct"
          :library="{
            scales: {
              xAxes: [
                {
                  type: 'time', time: { unit: 'hour', displayFormats: { hour: 'MMM DD HH:mm' } },
                  ticks: {
                    fontColor: '#000000',
                  },
                },
              ],
              yAxes: [
                {
                  ticks: {
                    fontColor: '#000000',
                  },
                },
              ],
            },
          }"
          :data="nDirectSeries"
        ></line-chart>
        <line-chart
          :colors="['#fcba03']"
          :height="150"
          ytitle="# Cloud"
          :library="{
            scales: {
              xAxes: [
                {
                  type: 'time', time: { unit: 'hour', displayFormats: { hour: 'MMM DD HH:mm' } },
                  ticks: {
                    fontColor: '#000000',
                  },
                },
              ],
              yAxes: [
                {
                  ticks: {
                    fontColor: '#000000',
                  },
                },
              ],
            },
          }"
          :data="nCloudSeries"
        ></line-chart>

        <line-chart
          v-if="freeGbSeries && freeGbSeries.length > 0"
          :colors="['#fcba03']"
          :height="150"
          ytitle="free GB"
          :library="{
            scales: {
              xAxes: [
                {
                  type: 'time', time: { unit: 'hour', displayFormats: { hour: 'MMM DD HH:mm' } },
                  ticks: {
                    fontColor: '#000000',
                  },
                },
              ],
              yAxes: [
                {
                  ticks: {
                    fontColor: '#000000',
                  },
                },
              ],
            },
          }"
          :data="freeGbSeries"
        ></line-chart>
        <line-chart
          v-if="vSeries && vSeries.length > 0"
          :colors="['#fcba03']"
          :height="150"
          ytitle="V"
          :library="{
            scales: {
              xAxes: [
                {
                  type: 'time', time: { unit: 'hour', displayFormats: { hour: 'MMM DD HH:mm' } },
                  ticks: {
                    fontColor: '#000000',
                  },
                },
              ],
              yAxes: [
                {
                  ticks: {
                    fontColor: '#000000',
                  },
                },
              ],
            },
          }"
          :data="vSeries"
        ></line-chart>
        <line-chart
          v-if="ovfSeries && ovfSeries.length > 0"
          :colors="['#fcba03']"
          :height="150"
          ytitle="Overflow"
          :library="{
            scales: {
              xAxes: [
                {
                  type: 'time', time: { unit: 'hour', displayFormats: { hour: 'MMM DD HH:mm' } },
                  ticks: {
                    fontColor: '#000000',
                  },
                },
              ],
              yAxes: [
                {
                  ticks: {
                    fontColor: '#000000',
                  },
                },
              ],
            },
          }"
          :data="ovfSeries"
        ></line-chart>
        <line-chart
          v-if="postTimeSeries && postTimeSeries.length > 0"
          :colors="['#fcba03']"
          :height="150"
          ytitle="POST time"
          :library="{
            scales: {
              xAxes: [
                {
                  type: 'time', time: { unit: 'hour', displayFormats: { hour: 'MMM DD HH:mm' } },
                  ticks: {
                    fontColor: '#000000',
                  },
                },
              ],
              yAxes: [
                {
                  ticks: {
                    fontColor: '#000000',
                  },
                },
              ],
            },
          }"
          :data="postTimeSeries"
        ></line-chart>
      </div>
      <!-- <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header>Text Warnings</v-expansion-panel-header>
            <v-expansion-panel-content
              v-for="item in haikuboxStatus"
              :key="item.id"
            >
              <template v-if="item.warning != ''">
                Date: {{ item.createdAt }}
                {{ item.warning }}
              </template>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels> -->
    </v-card>
    <v-container fluid>
      <v-row dense>
        <v-btn color="yellow" plain v-if="hitsLoading > 0">
            {{ "Loading" }} {{ hitsLoading }}</v-btn
          >

          <!-- Calendar Picker -->
          <v-btn
            fab
            small
            class="pa-1 ma-1"
            :color="recentHours == 0 ? 'blue lighten-2' : 'grey'"
            @click="hitSelectDate()"
            ><v-icon alt="calendar">mdi-calendar</v-icon>
          </v-btn>

          <template v-if="hitCalendarDatePicked == false">
        <v-row justify="center">
          <v-date-picker
            v-model="hitDatePicker"
            @change="hitDateClick()"
          ></v-date-picker>
        </v-row>
      </template>

      <!-- Recent card loop -->
      <v-container>
        <v-row dense>
          <v-col
            cols="12"
            xs="12"
            sm="6"
            md="6"
            lg="4"
            xl="3"
            v-for="(item, index) in hits"
            :key="item.id"
          >
            <v-card
              color="light-blue darken-4"
              class="mx-auto mx-auto"
              style="word-break: break-word"
              dark
            >
              <v-card-title>{{ item.cn }}</v-card-title>
              <v-card-subtitle class="font-italic">{{
                item.sn
              }}</v-card-subtitle>

              <v-row justify="end" class="px-8 my-0">
                <v-switch
                  dense
                  class="mr-5 py-0"
                  v-model="item.notifyBird"
                  v-tooltip.bottom-start="
                    'Send notification when this species is detected'
                  "
                  label="Notify"
                  color="info"
                  disabled
                ></v-switch>

                <v-switch
                  dense
                  class="py-0"
                  v-model="item.showBird"
                  v-tooltip.bottom-start="
                    'Turning Show OFF will hide this species on M and H setting'
                  "
                  :label="'Show'"
                  color="info"
                  disabled
                ></v-switch>
              </v-row>

              <!-- Recent Image -->
              <v-card-subtitle class="py-0">
                <img
                  width="100%"
                  v-if="item.window == 'image'"
                  :src="getImageUrl(item.spCode)"
                  onerror="this.onerror=null;this.src='https://haikubox-images.s3.amazonaws.com/placeholder.jpeg';"
                />

                <!-- Recent 24 Hour Donut Chart -->
                <div v-if="item.window == 'daily'">
                  <fusioncharts
                    type="doughnut2d"
                    width="100%"
                    height="240"
                    dataFormat="json"
                    :dataSource="item.hourlyCountPlotData"
                  >
                  </fusioncharts>
                </div>
                <!-- Recent 14 day heat map -->
                <div v-if="item.window == 'heatmap'">
                  <Plotly
                    :data="item.heatmap"
                    :display-mode-bar="false"
                    :layout="plotlyLayoutHeatmap"
                  ></Plotly>
                </div>

                <!-- Recent Daily Time Series -->
                <div v-if="item.window == 'monthly'">
                  <v-card-text class="ma-3"
                    ><v-icon>mdi-music-note</v-icon>
                    Past 3 Months

                    <!-- <span
                      class="font-weight-white"
                      v-text="getDailySpeciesCount(item.cn)"
                    ></span> -->
                  </v-card-text>
                  <column-chart
                    :colors="['#90A4AE']"
                    :height="300"
                    :library="{
                      scales: {
                        xAxes: [
                          {
                            ticks: {
                              fontColor: '#ffffff',
                            },
                          },
                        ],
                        yAxes: [
                          {
                            ticks: {
                              fontColor: '#ffffff',
                            },
                          },
                        ],
                      },
                    }"
                    :data="item.dailyCountPlotData"
                  ></column-chart>
                </div>

                <!-- Recent Spectrogram -->
                <div v-if="item.window == 'spectrogram'">
                  <Plotly
                    :data="item.spectrogram"
                    :layout="plotlyLayout"
                    :display-mode-bar="false"
                  ></Plotly>
                  <v-row no-gutters>
                    <v-col cols="1">0</v-col>
                    <v-col cols="1"></v-col>
                    <v-col cols="1"></v-col>
                    <v-col cols="1"></v-col>
                    <v-col cols="1"></v-col>
                    <v-col cols="1"></v-col>
                    <v-col cols="1"></v-col>
                    <v-col cols="1"></v-col>
                    <v-col cols="1"></v-col>
                    <v-col cols="1"></v-col>
                    <v-col cols="1"></v-col>
                    <!-- <v-col cols="1" class="d-flex justify-end">{{clipSeconds}}</v-col> -->
                  </v-row>
                </div>

                <!-- Recent Map -->
                <div v-if="item.window == 'map'">
                  <l-map
                    :center="center"
                    :options="hitMapOptions"
                    :bounds="bounds"
                    style="height: 240px; width: 100%"
                    @update:center="centerUpdate"
                    @update:zoom="zoomUpdate"
                    :zoomControl="false"
                    :zoom="zoom"
                    :maxZoom="maxZoomHitMap"
                  >
                    <l-tile-layer
                      :url="urlSummary"
                      :attribution="attributionSummary"
                    />
                    <l-circle
                      v-for="countPerHaikubox in item.map"
                      :key="countPerHaikubox.id"
                      :lat-lng="[countPerHaikubox.lat, countPerHaikubox.lon]"
                      :radius="countPerHaikubox.radius"
                      color="#0277BD"
                      fillColor="#039BE5"
                    />
                  </l-map>
                </div>
              </v-card-subtitle>

              <v-row class="my-0 py-0">
                <v-card-text class="my-0 py-0">
                  <!-- <v-btn
                    text
                    v-if="item.lon < -30"
                    :href="
                      item.lon > -30
                        ? 'https://ebird.org/species/' + item.spCode
                        : 'https://www.allaboutbirds.org/guide/' +
                          replaceSpaces(item.cn)
                    "
                    target="_blank"
                    color="light-blue"
                    >{{ "About" }}</v-btn
                  > -->
                  <v-btn
                    text
                    @click="navigateTo('https://ebird.org/species/' + item.spCode)"
                    target="_blank"
                    color="light-blue"
                    >eBird</v-btn
                  >
                </v-card-text>

                <v-spacer></v-spacer>
              </v-row>

              <!-- Recent Navigation -->
              <v-row class="mb-1" no-gutters>
                <v-col cols="8">
                  <v-avatar
                    class="ml-4"
                    size="24"
                    v-tooltip.bottom-start="'Image'"
                    @click="
                      setWindowRecent(index, 'image', item.spCode, item.cn)
                    "
                  >
                    <img
                      :width="$vuetify.breakpoint.xs ? '100%' : '320'"
                      :src="
                        'https://haikubox-images.s3.amazonaws.com/' +
                        item.spCode +
                        '.jpeg'
                      "
                      onerror="this.onerror=null;this.src='https://haikubox-images.s3.amazonaws.com/placeholder.jpeg';"
                    />
                  </v-avatar>

                  <v-btn
                    icon
                    class="ml-0"
                    v-tooltip.bottom-start="'Hourly Chart'"
                    @click="
                      setWindowRecent(index, 'daily', item.spCode, item.cn)
                    "
                    v-if="recentHours != 0"
                  >
                    <v-icon alt="hourly chart">mdi-chart-donut</v-icon>
                  </v-btn>
                  <v-btn
                    icon
                    class="ml-0"
                    v-tooltip.bottom-start="'Daily Chart'"
                    @click="
                      setWindowRecent(index, 'monthly', item.spCode, item.cn)
                    "
                  >
                    <v-icon alt="daily chart">mdi-chart-bar</v-icon>
                  </v-btn>
                  <v-btn
                    icon
                    class="ml-0"
                    v-tooltip.bottom-start="'Heat Map'"
                    @click="
                      setWindowRecent(index, 'heatmap', item.spCode, item.cn)
                    "
                  >
                    <v-icon alt="heat map">mdi-checkerboard</v-icon>
                  </v-btn>
                  <v-btn
                    icon
                    class="ml-0"
                    v-tooltip.bottom-start="'Map'"
                    @click="setWindowRecent(index, 'map', item.spCode, item.cn)"
                    v-if="recentHours != 0"
                  >
                    <v-icon alt="map">mdi-earth</v-icon>
                  </v-btn>
                  <v-btn
                    icon
                    class="ml-0"
                    v-tooltip.bottom-start="'Spectrogram'"
                    @click="
                      spectrogram(index, item.currentWav['filename'], 'Recent')
                    "
                  >
                    <v-icon alt="spectrogram">mdi-chart-bubble</v-icon>
                  </v-btn>
                </v-col>

                <v-spacer></v-spacer>

                <v-btn
                  v-tooltip.bottom-start="'Share sound'"
                  @click="
                    shareLink(item.spCode, item.cn, item.currentWav['filename'])
                  "
                  color="light-blue darken-1"
                  @click.stop="shareDialog = true"
                  class="ml-0 mr-2"
                  >{{ "Share" }}
                </v-btn>
              </v-row>

              <!-- Recent Play -->
              <div>
                <v-card-actions class="mx-0 my-0 py-0">
                  <v-row
                    ><v-col cols="12">
                      <v-btn
                        class="mx-1 my-1"
                        @click="
                          playFile(
                            item.currentWav['filename'],
                            item.spCode,
                            item.cn,
                            item,
                            index,
                            false
                          )
                        "
                        color="light-blue darken-1"
                      >
                        <v-icon left>mdi-play-circle</v-icon>
                        <v-divider class="mx-1" vertical></v-divider>
                        {{"Play" }}
                      </v-btn>
                      <v-btn
                        class="mx-1"
                        @click="
                          playFileEnhance(
                            item.currentWav['filename'],
                            item.spCode,
                            item.cn,
                            item.id
                          )
                        "
                        color="light-blue darken-1"
                      >
                        <v-icon left>mdi-play-circle</v-icon>
                        <v-divider class="mx-1" vertical></v-divider>
                        {{ "Enhance" }}
                      </v-btn>
                      </v-col
                    >
                    <v-col cols="12">
                      <v-select
                        class="mx-2 my-0 py-0"
                        :items="item.wavList"
                        v-model="item.currentWav"
                        item-text="listname"
                        item-value="filename"
                        @change="
                          playFile(
                            item.currentWav['filename'],
                            item.spCode,
                            item.cn,
                            item,
                            index,
                            true
                          )
                        "
                        return-object
                        single-line
                      ></v-select>
                    </v-col>
                  </v-row>
                </v-card-actions>
                <v-card-actions class="mx-0 my-0 py-0">
                  <v-row align="center" justify="center" no-gutter>
                    <v-col cols="12">
                      
                      <v-btn
                        class="mx-1 my-0"
                        color="light-blue darken-1"
                      >
                        <v-icon left>{{
                          item.favoriteHit ? "mdi-star" : "mdi-star-outline"
                        }}</v-icon>
                        <v-divider class="mx-1" vertical></v-divider>
                        {{ "Favorite" }}
                      </v-btn>
                      <v-btn
                        class="mx-2 my-0"
                        color="light-blue darken-1"
                        fab
                        small
                        dark
                        v-tooltip.bottom-start="'Download'"
                        @click="download(item)"
                        ><v-icon alt="download">mdi-download</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-actions>

                <!-- Recent Label -->
                <v-row no-gutters 
                  ><v-col cols="10">
                    <v-overflow-btn
                      class="mx-3 my-2"
                      v-if="item.wav"
                      @change="labelHit(index, item)"
                      :items="dropdown_class"
                      :background-color="
                        item.classLabel != null
                          ? 'light-blue darken-4'
                          : 'light-blue darken-1'
                      "
                      :label="labelText(item.cn)"
                      target="#label_sound"
                      v-model="item.classLabel"
                    ></v-overflow-btn>

                    <v-text-field
                      v-if="item.showEntryBox == true"
                      counter="50"
                      maxlength="50"
                      v-model="item.tellUsMore"
                      :placeholder="'What is this sound?'"
                      :label="'This sound is a:'"
                      outlined
                      :hint="item.submitted == true ? 'Submitted' : ''"
                      persistent-hint
                    >
                    </v-text-field>

                    <v-btn
                      v-if="item.showSubmitBox == true"
                      @click="labelHitCustom(index, item)"
                      class="ma-2"
                      color="light-blue darken-1"
                      >{{ "Submit" }}</v-btn
                    >
                  </v-col>
                  <v-col cols="2">
                    <v-dialog width="300">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn icon v-bind="attrs" v-on="on" class="my-6 mx-3">
                          <v-icon alt=" labeling information"
                            >mdi-information</v-icon
                          >
                        </v-btn>
                      </template>

                      <v-card>
                        <v-card-title class="headline grey lighten-2">
                          {{ "About Labeling" }}
                        </v-card-title>

                        <v-card-text>
                          {{ "Label Info" }}
                        </v-card-text>
                      </v-card>
                    </v-dialog>
                  </v-col>
                </v-row>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-container>

      </v-row>

    </v-container>
  </v-container>
</template>

<script>
import { API, Storage } from "aws-amplify";
import {
  statusByDate,
  haikuboxByType,
  getDeviceState,
  bootBySerialByDate,
  hitBySerialByDate,
  haikuboxByOwner,
  haikuboxUserByEmail,
  listHaikuboxUsers,
  getNoticeDescription,
  deviceHistoryByDate,
  getOneSignalConsent,
  getHaikuboxUser,
  getDevice,
  getSubscription,
  hideBirdBySerial,
  notifyBirdBySerial,
  getFavoriteHit,
  dailyCountSummaryByDateBySpecies,
} from "../graphql/queries";
// import { createUserNotice } from "../graphql/mutations";
import { createLabeledData } from "../graphql/mutations";
var moment = require("moment-timezone");
import { LCircle } from "vue2-leaflet";
// import FusionCharts from "fusioncharts";
import { Plotly } from "vue-plotly";
// https://github.com/chrisguttandin/standardized-audio-context
import { AudioContext, decodeAudioData } from "standardized-audio-context";
//const AudioContext = window.AudioContext || window.webkitAudioContext;

var hann = [
  0.0, 3.77965773e-5, 1.51180595e-4, 3.4013491e-4, 6.04630957e-4, 9.44628746e-4,
  1.36007687e-3, 1.85091253e-3, 2.41706151e-3, 3.05843822e-3, 3.77494569e-3,
  4.56647559e-3, 5.43290826e-3, 6.3741127e-3, 7.38994662e-3, 8.48025644e-3,
  9.64487731e-3, 1.08836332e-2, 1.21963367e-2, 1.35827895e-2, 1.50427819e-2,
  1.65760932e-2, 1.81824916e-2, 1.98617342e-2, 2.16135671e-2, 2.34377255e-2,
  2.53339336e-2, 2.73019047e-2, 2.93413412e-2, 3.1451935e-2, 3.36333667e-2,
  3.58853068e-2, 3.82074146e-2, 4.05993391e-2, 4.30607187e-2, 4.55911813e-2,
  4.81903443e-2, 5.08578147e-2, 5.35931893e-2, 5.63960544e-2, 5.92659864e-2,
  6.22025514e-2, 6.52053053e-2, 6.82737943e-2, 7.14075543e-2, 7.46061116e-2,
  7.78689827e-2, 8.11956742e-2, 8.45856832e-2, 8.80384971e-2, 9.1553594e-2,
  9.51304424e-2, 9.87685015e-2, 1.02467221e-1, 1.06226043e-1, 1.10044397e-1,
  1.13921708e-1, 1.17857388e-1, 1.21850843e-1, 1.25901469e-1, 1.30008654e-1,
  1.34171776e-1, 1.38390206e-1, 1.42663307e-1, 1.46990432e-1, 1.51370928e-1,
  1.55804131e-1, 1.60289372e-1, 1.64825973e-1, 1.69413247e-1, 1.74050502e-1,
  1.78737036e-1, 1.8347214e-1, 1.88255099e-1, 1.9308519e-1, 1.97961681e-1,
  2.02883837e-1, 2.07850913e-1, 2.12862158e-1, 2.17916814e-1, 2.23014117e-1,
  2.28153297e-1, 2.33333576e-1, 2.38554171e-1, 2.43814294e-1, 2.49113148e-1,
  2.54449933e-1, 2.59823842e-1, 2.65234062e-1, 2.70679775e-1, 2.76160159e-1,
  2.81674384e-1, 2.87221617e-1, 2.92801019e-1, 2.98411747e-1, 3.04052952e-1,
  3.09723782e-1, 3.15423378e-1, 3.21150881e-1, 3.26905422e-1, 3.32686134e-1,
  3.38492141e-1, 3.44322565e-1, 3.50176526e-1, 3.56053138e-1, 3.61951513e-1,
  3.6787076e-1, 3.73809982e-1, 3.79768282e-1, 3.8574476e-1, 3.91738511e-1,
  3.97748631e-1, 4.03774209e-1, 4.09814335e-1, 4.15868096e-1, 4.21934577e-1,
  4.2801286e-1, 4.34102027e-1, 4.40201156e-1, 4.46309327e-1, 4.52425614e-1,
  4.58549094e-1, 4.64678841e-1, 4.70813928e-1, 4.76953428e-1, 4.83096412e-1,
  4.89241951e-1, 4.95389117e-1, 5.0153698e-1, 5.07684611e-1, 5.1383108e-1,
  5.19975458e-1, 5.26116815e-1, 5.32254225e-1, 5.38386758e-1, 5.44513487e-1,
  5.50633486e-1, 5.56745831e-1, 5.62849596e-1, 5.68943859e-1, 5.75027699e-1,
  5.81100196e-1, 5.87160431e-1, 5.93207489e-1, 5.99240456e-1, 6.05258418e-1,
  6.11260467e-1, 6.17245695e-1, 6.23213197e-1, 6.2916207e-1, 6.35091417e-1,
  6.41000339e-1, 6.46887944e-1, 6.52753341e-1, 6.58595644e-1, 6.6441397e-1,
  6.70207439e-1, 6.75975174e-1, 6.81716305e-1, 6.87429962e-1, 6.93115283e-1,
  6.98771407e-1, 7.0439748e-1, 7.09992651e-1, 7.15556073e-1, 7.21086907e-1,
  7.26584315e-1, 7.32047467e-1, 7.37475536e-1, 7.42867702e-1, 7.4822315e-1,
  7.5354107e-1, 7.58820659e-1, 7.64061117e-1, 7.69261652e-1, 7.74421479e-1,
  7.79539817e-1, 7.84615893e-1, 7.89648938e-1, 7.94638193e-1, 7.99582902e-1,
  8.04482319e-1, 8.09335702e-1, 8.14142317e-1, 8.18901439e-1, 8.23612347e-1,
  8.28274329e-1, 8.32886681e-1, 8.37448705e-1, 8.41959711e-1, 8.46419017e-1,
  8.5082595e-1, 8.55179843e-1, 8.59480037e-1, 8.63725883e-1, 8.67916738e-1,
  8.7205197e-1, 8.76130952e-1, 8.80153069e-1, 8.84117711e-1, 8.88024281e-1,
  8.91872186e-1, 8.95660845e-1, 8.99389686e-1, 9.03058145e-1, 9.06665667e-1,
  9.10211707e-1, 9.13695728e-1, 9.17117204e-1, 9.20475618e-1, 9.23770461e-1,
  9.27001237e-1, 9.30167455e-1, 9.33268638e-1, 9.36304317e-1, 9.39274033e-1,
  9.42177336e-1, 9.45013788e-1, 9.4778296e-1, 9.50484434e-1, 9.531178e-1,
  9.55682662e-1, 9.5817863e-1, 9.60605328e-1, 9.62962389e-1, 9.65249456e-1,
  9.67466184e-1, 9.69612237e-1, 9.71687291e-1, 9.73691033e-1, 9.75623159e-1,
  9.77483377e-1, 9.79271407e-1, 9.80986977e-1, 9.82629829e-1, 9.84199713e-1,
  9.85696393e-1, 9.87119643e-1, 9.88469246e-1, 9.89745e-1, 9.90946711e-1,
  9.92074198e-1, 9.9312729e-1, 9.94105827e-1, 9.95009663e-1, 9.9583866e-1,
  9.96592693e-1, 9.97271648e-1, 9.97875422e-1, 9.98403924e-1, 9.98857075e-1,
  9.99234805e-1, 9.99537058e-1, 9.99763787e-1, 9.99914959e-1, 9.99990551e-1,
  9.99990551e-1, 9.99914959e-1, 9.99763787e-1, 9.99537058e-1, 9.99234805e-1,
  9.98857075e-1, 9.98403924e-1, 9.97875422e-1, 9.97271648e-1, 9.96592693e-1,
  9.9583866e-1, 9.95009663e-1, 9.94105827e-1, 9.9312729e-1, 9.92074198e-1,
  9.90946711e-1, 9.89745e-1, 9.88469246e-1, 9.87119643e-1, 9.85696393e-1,
  9.84199713e-1, 9.82629829e-1, 9.80986977e-1, 9.79271407e-1, 9.77483377e-1,
  9.75623159e-1, 9.73691033e-1, 9.71687291e-1, 9.69612237e-1, 9.67466184e-1,
  9.65249456e-1, 9.62962389e-1, 9.60605328e-1, 9.5817863e-1, 9.55682662e-1,
  9.531178e-1, 9.50484434e-1, 9.4778296e-1, 9.45013788e-1, 9.42177336e-1,
  9.39274033e-1, 9.36304317e-1, 9.33268638e-1, 9.30167455e-1, 9.27001237e-1,
  9.23770461e-1, 9.20475618e-1, 9.17117204e-1, 9.13695728e-1, 9.10211707e-1,
  9.06665667e-1, 9.03058145e-1, 8.99389686e-1, 8.95660845e-1, 8.91872186e-1,
  8.88024281e-1, 8.84117711e-1, 8.80153069e-1, 8.76130952e-1, 8.7205197e-1,
  8.67916738e-1, 8.63725883e-1, 8.59480037e-1, 8.55179843e-1, 8.5082595e-1,
  8.46419017e-1, 8.41959711e-1, 8.37448705e-1, 8.32886681e-1, 8.28274329e-1,
  8.23612347e-1, 8.18901439e-1, 8.14142317e-1, 8.09335702e-1, 8.04482319e-1,
  7.99582902e-1, 7.94638193e-1, 7.89648938e-1, 7.84615893e-1, 7.79539817e-1,
  7.74421479e-1, 7.69261652e-1, 7.64061117e-1, 7.58820659e-1, 7.5354107e-1,
  7.4822315e-1, 7.42867702e-1, 7.37475536e-1, 7.32047467e-1, 7.26584315e-1,
  7.21086907e-1, 7.15556073e-1, 7.09992651e-1, 7.0439748e-1, 6.98771407e-1,
  6.93115283e-1, 6.87429962e-1, 6.81716305e-1, 6.75975174e-1, 6.70207439e-1,
  6.6441397e-1, 6.58595644e-1, 6.52753341e-1, 6.46887944e-1, 6.41000339e-1,
  6.35091417e-1, 6.2916207e-1, 6.23213197e-1, 6.17245695e-1, 6.11260467e-1,
  6.05258418e-1, 5.99240456e-1, 5.93207489e-1, 5.87160431e-1, 5.81100196e-1,
  5.75027699e-1, 5.68943859e-1, 5.62849596e-1, 5.56745831e-1, 5.50633486e-1,
  5.44513487e-1, 5.38386758e-1, 5.32254225e-1, 5.26116815e-1, 5.19975458e-1,
  5.1383108e-1, 5.07684611e-1, 5.0153698e-1, 4.95389117e-1, 4.89241951e-1,
  4.83096412e-1, 4.76953428e-1, 4.70813928e-1, 4.64678841e-1, 4.58549094e-1,
  4.52425614e-1, 4.46309327e-1, 4.40201156e-1, 4.34102027e-1, 4.2801286e-1,
  4.21934577e-1, 4.15868096e-1, 4.09814335e-1, 4.03774209e-1, 3.97748631e-1,
  3.91738511e-1, 3.8574476e-1, 3.79768282e-1, 3.73809982e-1, 3.6787076e-1,
  3.61951513e-1, 3.56053138e-1, 3.50176526e-1, 3.44322565e-1, 3.38492141e-1,
  3.32686134e-1, 3.26905422e-1, 3.21150881e-1, 3.15423378e-1, 3.09723782e-1,
  3.04052952e-1, 2.98411747e-1, 2.92801019e-1, 2.87221617e-1, 2.81674384e-1,
  2.76160159e-1, 2.70679775e-1, 2.65234062e-1, 2.59823842e-1, 2.54449933e-1,
  2.49113148e-1, 2.43814294e-1, 2.38554171e-1, 2.33333576e-1, 2.28153297e-1,
  2.23014117e-1, 2.17916814e-1, 2.12862158e-1, 2.07850913e-1, 2.02883837e-1,
  1.97961681e-1, 1.9308519e-1, 1.88255099e-1, 1.8347214e-1, 1.78737036e-1,
  1.74050502e-1, 1.69413247e-1, 1.64825973e-1, 1.60289372e-1, 1.55804131e-1,
  1.51370928e-1, 1.46990432e-1, 1.42663307e-1, 1.38390206e-1, 1.34171776e-1,
  1.30008654e-1, 1.25901469e-1, 1.21850843e-1, 1.17857388e-1, 1.13921708e-1,
  1.10044397e-1, 1.06226043e-1, 1.02467221e-1, 9.87685015e-2, 9.51304424e-2,
  9.1553594e-2, 8.80384971e-2, 8.45856832e-2, 8.11956742e-2, 7.78689827e-2,
  7.46061116e-2, 7.14075543e-2, 6.82737943e-2, 6.52053053e-2, 6.22025514e-2,
  5.92659864e-2, 5.63960544e-2, 5.35931893e-2, 5.08578147e-2, 4.81903443e-2,
  4.55911813e-2, 4.30607187e-2, 4.05993391e-2, 3.82074146e-2, 3.58853068e-2,
  3.36333667e-2, 3.1451935e-2, 2.93413412e-2, 2.73019047e-2, 2.53339336e-2,
  2.34377255e-2, 2.16135671e-2, 1.98617342e-2, 1.81824916e-2, 1.65760932e-2,
  1.50427819e-2, 1.35827895e-2, 1.21963367e-2, 1.08836332e-2, 9.64487731e-3,
  8.48025644e-3, 7.38994662e-3, 6.3741127e-3, 5.43290826e-3, 4.56647559e-3,
  3.77494569e-3, 3.05843822e-3, 2.41706151e-3, 1.85091253e-3, 1.36007687e-3,
  9.44628746e-4, 6.04630957e-4, 3.4013491e-4, 1.51180595e-4, 3.77965773e-5, 0.0,
];
var fft = require("fft-js").fft,
  ifft = require("fft-js").ifft;
import { FFT } from "dsp.js";
import { unmute } from "../unmute.min.js";
let globalAudioContext = null;
let globalGainNode = null;

export default {
  props: ["user"],
  created() {
    this.getDeviceHistory();
    this.getHaikuboxList();
  },
  components: {
    Plotly,
    LCircle,
  },
  data() {
    return {
      haikubox: "",
      noticeId: "",
      noticeDescription: "",
      usersList: [],
      haikuboxList: [],
      haikuboxProps: [],
      subscriptionProps: [],
      haikuboxHeaders: [
        {
          text: "Name",
          align: "start",
          sortable: true,
          value: "name",
        },
        { text: "Serial", value: "serial" },
        { text: "Owner", value: "owner" },
        { text: "New Bird Alert", value: "newBirdAlert" },
        { text: "Hide", value: "hideOnMap" },
        { text: "Lat", value: "lat" },
        { text: "Lon", value: "lon" },
        { text: "Share Cornell", value: "shareBird" },
        { text: "Created", value: "createdAt" },
        { text: "Updated", value: "updatedAt" },
      ],
      historyHeaders: [
        {
          text: "Name",
          align: "start",
          sortable: true,
          value: "name",
        },
        { text: "Serial", value: "serial" },
        { text: "Action", value: "deviceAction" },
        { text: "Owner", value: "owner" },
        { text: "lat", value: "lat" },
        { text: "lon", value: "lon" },
        { text: "Share Cornell", value: "shareBird" },
        { text: "Created", value: "createdAt" },
      ],
      subscriptionHeaders: [
        {
          text: "Serial",
          align: "start",
          sortable: true,
          value: "id",
        },
        { text: "Type", value: "prepaidType" },
        { text: "Prepaid End UTC", value: "prepaidPeriodEndUnix" },
        { text: "Stripe Renewal End UTC", value: "stripeCurrentPeriodEndUnix" },
        { text: "autoRenew", value: "autoRenew" },
        { text: "Created", value: "createdAt" },
        { text: "Updated", value: "updatedAt" },
      ],
      deviceHistory: [],
      userIdList: [],
      cpuTempSeries: [],
      cpuFreqSeries: [],
      ramdiskSeries: [],
      signalSeries: [],
      nDirectSeries: [],
      nCloudSeries: [],
      freeGbSeries: [],
      vSeries: [],
      ovfSeries: [],
      postTimeSeries: [],
      bootTable: [],
      getUsersByEmail: null,
      currentWiFi: 0,
      firmwareVersion: 0,
      timezone: "",
      currentSerial: "",
      hits: [],
      recentHours: 24,
      playbackGain: 100,
      fftLength: 512,
      halfLength: 256,
      customHiddenList: [],
      hitsLoading: 0,
      selectedLanguage: "en",
      currentTimezone: "America/New_York",
      currentView: "Recent",
      email: "",
      userID: "",
      lat: 0.0,
      lon: 0.0,
      confirmedEmail: null,
      accountUpdatedAt: null,
      numHaikuboxes: null,
      oneSignalConsentGranted: false,
      hitCalendarDatePicked: true,
      hitDatePicker: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10),
      fusionSchema: [
        {
          name: "Time",
          type: "date",
          format: "%Y-%m-%d %H:%M",
        },
        {
          name: "Detections",
          type: "number",
        },
      ],
      fusionSchemaDaily: [
        {
          name: "Date",
          type: "date",
          format: "%Y-%m-%d",
        },
        {
          name: "Detections",
          type: "number",
        },
      ],
      dataSource: {
        data: null,
        legend: {
          enabled: "0",
        },
        navigator: {
          enabled: 0,
        },
        caption: {
          text: "Detections",
        },
        subcaption: {
          text: "All Species",
        },
        extensions: {
          customRangeSelector: {
            enabled: "0",
          },
        },
        yAxis: [
          {
            plot: {
              value: "Detections",
              type: "column",
            },
            format: {
              prefix: "",
            },
            title: "Avg/15 minutes",
          },
        ],
      },
      plotlyLayoutHeatmap: {
        xaxis: {
          autorange: true,
          showgrid: false,
          zeroline: false,
          showline: false,
          autotick: true,
          ticks: "",
          showticklabels: true,
          fixedrange: true,
        },
        yaxis: {
          autorange: true,
          showgrid: false,
          zeroline: false,
          showline: false,
          autotick: true,
          ticks: "",
          showticklabels: true,
          fixedrange: true,
        },
        title: "Calls Per Hour",
        margin: {
          l: 60,
          r: 40,
          b: 60,
          t: 40,
          pad: 4,
        },
        height: 300,
        hovermode: false,
      },
      plotlyLayout: {
        xaxis: {
          autorange: true,
          showgrid: false,
          zeroline: false,
          showline: false,
          autotick: true,
          ticks: "",
          showticklabels: false,
          fixedrange: true,
        },
        yaxis: {
          autorange: true,
          showgrid: false,
          zeroline: false,
          showline: false,
          autotick: true,
          ticks: "",
          showticklabels: false,
          fixedrange: true,
        },
        margin: {
          l: 0,
          r: 0,
          b: 0,
          t: 0,
          pad: 4,
        },
        height: 240,
        hovermode: false,
      },
      urlStates:
        "https://server.arcgisonline.com/ArcGIS/rest/services/NatGeo_World_Map/MapServer/tile/{z}/{y}/{x}",
      attributionSummary:
        "Tiles &copy; Esri &mdash; National Geographic, Esri, DeLorme, NAVTEQ, UNEP-WCMC, USGS, NASA, ESA, METI, NRCAN, GEBCO, NOAA, iPC",
    };
  },
  watch: {
    async getUsersByEmail(val) {
      // console.log("getUsersByEmail", val);
      var nextToken = null;
      var tempList = [];
      do {
        const filteredUsers = await API.graphql({
          query: listHaikuboxUsers,
          variables: {
            nextToken: nextToken,
            filter: { email: { contains: val } },
          },
        });
        var usersList = filteredUsers.data.listHaikuboxUsers.items;
        nextToken = filteredUsers.data.listHaikuboxUsers.nextToken;
        // console.log("getUsersByEmail", usersList);

        for (var i = 0; i < usersList.length; i++) {
          tempList.push(usersList[i].email);
        }
        if (tempList.length > 20) break;
      } while (nextToken != null);
      this.usersList = tempList;
      // console.log(this.usersList);
    },
  },
  computed: {
    dropdown_class() {
      const text = ["Yes","No","No it's a ...", "Not Sure"];
      // console.log(text);
      return text;
    },
    navList() {
      if (this.subscriptionActive == false) {
        return [
          {
            id: "Last 2 Hours",
            text: "Last 2 Hours",
            icon: "mdi-clock-outline",
          },
          {
            id: "Resubscribe",
            text: "ResubscribeInfo",
            icon: "mdi-meteor",
          },
        ];
      } else {
        return [
          {
            id: "Last 2 Hours",
            text: "Last 2 Hours",
            icon: "mdi-clock-outline",
          },
          {
            id: "Last 12 Hours",
            text: "Last 12 Hours",
            icon: "mdi-clock-outline",
          },
          {
            id: "Last 24 Hours",
            text: "Last 24 Hours",
            icon: "mdi-clock-outline",
          },
          {
            id: "Yesterday",
            text: "Yesterday",
            icon: "mdi-calendar-clock",
          },
          { id: "Live", text: "Live", icon: "mdi-meteor" },
          { id: "All", text: "All", icon: "mdi-ballot-outline" },
        ];
      }
    },
  },
  methods: {
    getImageUrl(spCode) {
      var imageUrl =
        "https://haikubox-images.s3.amazonaws.com/" + spCode + ".jpeg";
      return imageUrl;
    },
    navigateTo(url) {
      console.log('navigatTo', url);
      window.open(url, '_blank');
    },
    replaceSpaces(itemWithSpaces) {
      const itemWithUnderscores = itemWithSpaces.replace(/ /g, "_");
      const itemWithApostrophe = itemWithUnderscores.replace(/'/g, "");
      const itemWithColon = itemWithApostrophe.replace(/:/g, "");
      const itemWithComma = itemWithColon.replace(/,/g, "");
      // console.log("link", itemWithColon);
      return itemWithComma;
    },
    labelText(commonName) {
      return "Is" + " " + commonName + " " + "Correct" + "?";
    },
    async download(item) {
      // console.log(item);
      let audioFile = item.currentWav["filename"];

      this.initAudioContext();

      if (globalAudioContext.state === "suspended") {
        globalAudioContext.resume();
      }

      globalGainNode.gain.value = this.playbackGain;
      if (audioFile[5] == "P" | audioFile[0] == "p") {
          globalGainNode.gain.value = globalGainNode.gain.value / 20;
      }

      var audioUrl = await Storage.get(audioFile);

      // Create a link element and trigger a flac download
      const link = document.createElement("a");
      link.href = audioUrl;
      link.download = audioFile;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      const response = await fetch(audioUrl);
      const arrayBuffer = await response.arrayBuffer();
      const audioBuffer = await globalAudioContext.decodeAudioData(arrayBuffer);
      let signal = audioBuffer.getChannelData(0);
      const max =
        1.5 * signal.reduce((acc, val) => Math.max(acc, val), -Infinity);
      const normalizedSignal = signal.map((value) => value / max);
      // console.log(audioBuffer);

      function saveArrayToWavFile(array, sampleRate, filename) {
        const numChannels = 1;
        const bitsPerSample = 16;
        const byteRate = (sampleRate * numChannels * bitsPerSample) / 8;
        const blockAlign = (numChannels * bitsPerSample) / 8;
        const dataSize = (array.length * bitsPerSample) / 8;
        const fileLength = 44 + dataSize;

        // Create a buffer for the WAV file
        const buffer = new ArrayBuffer(fileLength);
        const view = new DataView(buffer);

        // Write the WAV file header
        writeString(view, 0, "RIFF");
        view.setUint32(4, fileLength - 8, true);
        writeString(view, 8, "WAVE");
        writeString(view, 12, "fmt ");
        view.setUint32(16, 16, true);
        view.setUint16(20, 1, true);
        view.setUint16(22, numChannels, true);
        view.setUint32(24, sampleRate, true);
        view.setUint32(28, byteRate, true);
        view.setUint16(32, blockAlign, true);
        view.setUint16(34, bitsPerSample, true);
        writeString(view, 36, "data");
        view.setUint32(40, dataSize, true);

        // Write the sample data
        for (let i = 0; i < array.length; i++) {
          view.setInt16(44 + i * 2, array[i] * 32767, true);
        }

        // Convert the buffer to a Blob
        const blob = new Blob([buffer], { type: "audio/wav" });

        // Create a link element and trigger a wav download
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }

      function writeString(view, offset, string) {
        for (let i = 0; i < string.length; i++) {
          view.setUint8(offset + i, string.charCodeAt(i));
        }
      }
      let filename =
        this.replaceSpaces(item.cn) +
        "_" +
        this.replaceSpaces(item.currentWav["listname"]) +
        ".wav";
      saveArrayToWavFile(normalizedSignal, audioBuffer.sampleRate, filename);
    },
    initAudioContext() {
      if (globalAudioContext == null) {
        const isIOS = /iPhone|iPod|iPad/.test(navigator.userAgent);
        if (isIOS) {
          globalAudioContext = new AudioContext();
          // Note: audioContext, allowBackgroundPlayback, forceIOSBehavior
          unmute(globalAudioContext, false, false);
        } else {
          globalAudioContext = new AudioContext();
        }
        globalGainNode = globalAudioContext.createGain();
        globalGainNode.gain.value = this.playbackGain; // Set initial volume level
        globalGainNode.connect(globalAudioContext.destination);
      }
    },
    async playFile(audioFile, spCode, cn, item, index, resetLabel) {
      // console.log(item);
      // console.log("playFile", resetLabel);
      // reset label is true when playing from wav select dropdown
      if (resetLabel === true) {
        item.classLabel = null;
        // get favorite status for this file

        const favoriteHit = await API.graphql({
          query: getFavoriteHit,
          variables: {
            id: audioFile,
          },
        });

        if (favoriteHit.data.getFavoriteHit != null) {
          item.favoriteHit = true;
        } else {
          item.favoriteHit = false;
        }
        item.wav = audioFile;
      }
      console.log("playFile", audioFile);

      this.initAudioContext();

      if (globalAudioContext.state === "suspended") {
        globalAudioContext.resume();
      }

      globalGainNode.gain.value = this.playbackGain;

      var audioUrl = await Storage.get(audioFile);
      console.log(audioUrl);
      const response = await fetch(audioUrl);
      const arrayBuffer = await response.arrayBuffer();
      const audioBuffer = await globalAudioContext.decodeAudioData(arrayBuffer);

      const sampleSource = globalAudioContext.createBufferSource();
      sampleSource.buffer = audioBuffer;
      sampleSource.connect(globalGainNode);
      sampleSource.start(0);

      if (this.currentView == "Recent") {
        if (item.window == "spectrogram") {
          this.spectrogram(index, item.currentWav["filename"], "Recent");
          item.classLabel = null;
        }
      }
    },
    async playFileEnhance(audioFile, spCode, cn, id) {

      this.initAudioContext();
      if (globalAudioContext.state === "suspended") {
        globalAudioContext.resume();
      }

      // playing last file again
      if (this.lastEnhancedId == id) {
        // Create an AudioBufferSourceNode
        const sourceNode = globalAudioContext.createBufferSource();
        sourceNode.buffer = this.lastEnhancedAudio;
        // Connect the source node to the AudioContext's destination (speakers)
        sourceNode.connect(globalAudioContext.destination);
        // Start playback
        sourceNode.start();
        return;
      }

      async function getFile(filepath) {
        const response = await fetch(filepath);
        const arrayBuffer = await response.arrayBuffer();
        const audioBuffer = await decodeAudioData(
          globalAudioContext,
          arrayBuffer
        );
        return audioBuffer;
      }

      async function setupSample(filePath) {
        // var context = new AudioContext();
        const sample = await getFile(filePath);
        return sample;
      }

      Storage.get(audioFile).then((result) => {
        // console.log("Storage get", result);
        setupSample(result).then((sample) => {
          let signal = sample.getChannelData(0);
          // Define STFT parameters
          const fftSize = 512;
          const overlap = 256;
          const hopSize = fftSize - overlap;
          // Compute the STFT
          const stft = [];
          var meanMag = new Array(fftSize).fill(0);
          var stdMag = new Array(fftSize).fill(0);
          var numStrides = 0;
          for (let i = 0; i < signal.length - fftSize; i += hopSize) {
            const frame = signal.slice(i, i + fftSize);
            // Hanning Window
            for (var k = 0; k < fftSize; k++) {
              frame[k] = frame[k] * hann[k];
            }
            var phasors = fft(frame);
            // console.log(phasors);
            // store running sum of magnitude to calculate mean
            for (var j = 0; j < phasors.length; j++) {
              meanMag[j] += Math.sqrt(
                phasors[j][0] * phasors[j][0] + phasors[j][1] * phasors[j][1]
              );
            }
            numStrides++;
            stft.push([...phasors]);
          }
          // console.log('stft', stft);
          for (let j = 0; j < fftSize; j++) {
            meanMag[j] = meanMag[j] / numStrides;
          }
          // calculate SD
          // loop through each time slice
          for (let i = 0; i < stft.length; i++) {
            // loop through each frequency
            for (let j = 0; j < fftSize; j++) {
              let magnitude =
                Math.sqrt(
                  stft[i][j][0] * stft[i][j][0] + stft[i][j][1] * stft[i][j][1]
                ) - meanMag[j];
              stdMag[j] += magnitude * magnitude;
            }
          }
          for (j = 0; j < fftSize; j++) {
            stdMag[j] = Math.sqrt(stdMag[j] / numStrides);
          }
          // gate values based on mean + 2*SD
          async function gateSpectrogram() {
            for (let i = 0; i < stft.length - 4; i++) {
              // loop through each frequency
              for (let j = 0; j < fftSize; j++) {
                // get average magnitude over 5 time slices
                let magnitude =
                  (Math.sqrt(
                    stft[i][j][0] * stft[i][j][0] +
                      stft[i][j][1] * stft[i][j][1]
                  ) +
                    Math.sqrt(
                      stft[i + 1][j][0] * stft[i + 1][j][0] +
                        stft[i + 1][j][1] * stft[i + 1][j][1]
                    ) +
                    Math.sqrt(
                      stft[i + 2][j][0] * stft[i + 2][j][0] +
                        stft[i + 2][j][1] * stft[i + 2][j][1]
                    ) +
                    Math.sqrt(
                      stft[i + 3][j][0] * stft[i + 3][j][0] +
                        stft[i + 3][j][1] * stft[i + 3][j][1]
                    ) +
                    Math.sqrt(
                      stft[i + 4][j][0] * stft[i + 4][j][0] +
                        stft[i + 4][j][1] * stft[i + 4][j][1]
                    )) /
                  5;
                if (magnitude < meanMag[j] + 1.9 * stdMag[j]) {
                  stft[i][j][0] = stft[i][j][0] * 0.2;
                  stft[i][j][1] = stft[i][j][1] * 0.2;
                  // also flip mirror
                  stft[i][fftSize - 1 - j][0] =
                    stft[i][fftSize - 1 - j][0] * 0.2;
                  stft[i][fftSize - 1 - j][1] =
                    stft[i][fftSize - 1 - j][1] * 0.2;
                  // console.log(i, j);
                }
                if (j < 4) {
                  stft[i][j][0] = stft[i][j][0] * 0.2;
                  stft[i][j][1] = stft[i][j][1] * 0.2;
                  // also flip mirror
                  stft[i][fftSize - 1 - j][0] =
                    stft[i][fftSize - 1 - j][0] * 0.2;
                  stft[i][fftSize - 1 - j][1] =
                    stft[i][fftSize - 1 - j][1] * 0.2;
                  // console.log(i, j);
                }
              }
            }
            return stft;
          }
          // Compute the ISTFT
          async function istft() {
            let recoveredSignal = new Array(signal.length).fill(0);
            let recoveredSignalComplex = new Array(fftSize);
            for (let i = 0; i < stft.length - 4; i++) {
              // console.log('before ifft', stft[i]);
              recoveredSignalComplex = ifft(stft[i]);
              // console.log('recoveredSignalComplex', recoveredSignalComplex);
              for (let j = 0; j < fftSize; j++) {
                if (i * overlap + j < signal.length) {
                  // get real part
                  recoveredSignal[i * hopSize + j] +=
                    recoveredSignalComplex[j][0];
                }
              }
            }
            return recoveredSignal;
          }
          gateSpectrogram()
            .then(() => {
              //console.log(res);
              return istft();
            })
            .then((recoveredSignal) => {
              // console.log('recoveredSignal', recoveredSignal);
              var maxSignal = 0;
              for (let i = 0; i < recoveredSignal.length - 1000; i += 1000) {
                // get stack issues so doing in chunks
                var tempMax = Math.max(...recoveredSignal.slice(i, i + 1000));
                if (tempMax > maxSignal) {
                  maxSignal = tempMax;
                }
              }
              maxSignal = 0.9 / maxSignal; // scale so can multiply to get max amp of 0.9
              // console.log('maxValue', maxSignal);
              // Create an AudioBuffer from the audio data
              const audioBuffer = globalAudioContext.createBuffer(
                1,
                recoveredSignal.length,
                sample.sampleRate
              );
              const channelData = audioBuffer.getChannelData(0);
              for (let i = 0; i < recoveredSignal.length; i++) {
                channelData[i] = recoveredSignal[i] * maxSignal;
              }
              // Create an AudioBufferSourceNode
              const sourceNode = globalAudioContext.createBufferSource();
              sourceNode.buffer = audioBuffer;
              // Connect the source node to the AudioContext's destination (speakers)
              sourceNode.connect(globalAudioContext.destination);
              // Start playback
              sourceNode.start();
              this.lastEnhancedId = id;
              this.lastEnhancedAudio = audioBuffer;
            });
        });
      });
    },
    spectrogram(index, audioFile, pageType) {
      // console.log("Spectrogram", index, audioFile, pageType);

      this.initAudioContext();

      async function getFile(audioContext, filepath) {
        // webkit audio decodeAudioData does not work in Safari
        // const response = await fetch(filepath);
        // const arrayBuffer = await response.arrayBuffer();
        // const audioBuffer = await audioContext.decodeAudioData(arrayBuffer);
        // return audioBuffer;

        // standardized-audio-context from npm
        // const nativeAudioContext = new AudioContext();
        const response = await fetch(filepath);
        const arrayBuffer = await response.arrayBuffer();
        const audioBuffer = await decodeAudioData(
          globalAudioContext,
          arrayBuffer
        );
        return audioBuffer;
      }

      async function setupSample(filePath) {
        // var context = new AudioContext();
        const sample = await getFile(globalAudioContext, filePath);

        return sample;
      }

      function linear2Decibel(value) {
        var dB = 20 * Math.log10(value);
        return dB;
      }

      //var c = document.getElementById("myCanvas");
      //this.canvas = c.getContext("2d");

      Storage.get(audioFile)
        .then(
          (result) => {
            // console.log("Storage get", result);

            setupSample(result)
              .then((sample) => {
                // console.log("sample", sample);
                let signal = sample.getChannelData(0);
                // console.log("raw", signal);

                // calculate spectrogram
                // let ts = 0;

                let overlap = 0.0;
                let fftLength = this.fftLength;
                let halfLength = this.halfLength; // chop off top

                let showLength = halfLength - Math.round(0.2 * halfLength);
                let zmidVal = -90;
                if (audioFile[5] == "2") {
                  showLength = halfLength - Math.round(0.48 * halfLength);
                  zmidVal = -66;
                }
                if (audioFile[5] == "P" | audioFile[0] == "p") {
                  showLength = halfLength - Math.round(0.48 * halfLength);
                  zmidVal = -34;
                }

                let offset = Math.floor(fftLength * (1.0 - overlap));
                // console.log("offset", offset);
                // let ctx = this.canvas;
                let fft = new FFT(fftLength, 44100);

                var spectrogramArray = [];
                for (var x = 0; x < sample.length - fftLength; x += offset) {
                  var chunk = signal.slice(x, x + fftLength);
                  for (var i = 0; i < fftLength; i++) {
                    chunk[i] = chunk[i] * hann[i];
                  }
                  fft.forward(chunk);
                  chunk = fft.spectrum.slice(0, showLength);
                  // console.log("fft", chunk);
                  var dBmag = chunk.map(linear2Decibel);
                  // console.log("dB", dBmag);
                  spectrogramArray.push(...dBmag);
                }

                // console.log("spectrogramArray", spectrogramArray);
                // console.log('showLength', showLength);

                // arrange spectrogram for Plotly
                var spectrogramData = [];
                for (i = 0; i < showLength; i++) {
                  // grab one element every halfLength points
                  var arr = spectrogramArray.filter(function (value, j) {
                    return j % showLength == 0;
                  });
                  // console.log(arr);
                  spectrogramData.push(arr);
                  spectrogramArray.shift(); // remove first element
                }
                // console.log("spectrogramData", spectrogramData);

                if (pageType === "Recent") {
                  this.hits[index].spectrogram = [
                    {
                      z: spectrogramData,
                      type: "heatmap",
                      showscale: false,
                      zmid: zmidVal,
                    },
                  ];
                  // console.log("spec", this.hits[index].spectrogram);
                  this.setWindowRecent(
                    index,
                    "spectrogram",
                    this.hits[index].spCode,
                    this.hits[index].cn
                  );
                }
                if (pageType === "All") {
                  this.seriesDaily[index].spectrogram = [
                    {
                      z: spectrogramData,
                      type: "heatmap",
                      showscale: false,
                      zmid: zmidVal,
                    },
                  ];
                  this.setWindowAll(
                    index,
                    "spectrogram",
                    this.seriesDaily[index].spCode,
                    this.seriesDaily[index].cn
                  );
                }

                if (pageType === "New") {
                  this.newSpeciesList[index].spectrogram = [
                    {
                      z: spectrogramData,
                      type: "heatmap",
                      showscale: false,
                      zmid: zmidVal,
                    },
                  ];
                  this.setWindowNew(
                    index,
                    "spectrogram",
                    this.newSpeciesList[index].spCode,
                    this.newSpeciesList[index].cn
                  );
                }

                if (pageType === "Missing") {
                  this.missingSpeciesList[index].spectrogram = [
                    {
                      z: spectrogramData,
                      type: "heatmap",
                      showscale: false,
                      zmid: zmidVal,
                    },
                  ];
                  this.setWindowMissing(
                    index,
                    "spectrogram",
                    this.missingSpeciesList[index].spCode,
                    this.missingSpeciesList[index].cn
                  );
                }
              })
              .catch((err) => {
                console.log(err);
                console.log("No audio", audioFile);
                // console.log("Delete index", index);
                this.snackbar = true;
                return false;
              });
          },
          (reason) => {
            // rejection
            console.log("Can't play ", reason);
          }
        )
        .catch((err) => {
          console.log(err);
        });
    },
    clearSettings() {
      this.haikuboxProps = [];
      this.subscriptionProps = [];
      this.deviceHistory = [];
      this.haikubox = "";
      this.email = "";
      this.confirmedEmail = "";
      this.accountUpdatedAt = "";
      this.numHaikuboxes = 0;
      this.oneSignalConsentGranted = "";
      this.bootTable = [];
      this.firmwareVersion = "";
      this.cpuTempSeries = [];
      this.signalSeries = [];
      this.nDirectSeries = [];
      this.nCloudSeries = [];
      this.freeGbSeries = [];
      this.vSeries = [];
      this.ovfSeries = [];
      this.postTimeSeries = [];
      this.hits = [];
      this.lat = 0;
      this.lon = 0;
    },
    async getHaikuboxList() {
      this.clearSettings();
      var nextToken = null;
      var allHaikuboxes = [];
      var userIds = [];

      do {
        const devices = await API.graphql({
          query: haikuboxByType,
          variables: { type: "haikubox", nextToken: nextToken },
        });
        nextToken = devices.data.haikuboxByType.nextToken;
        allHaikuboxes = allHaikuboxes.concat(devices.data.haikuboxByType.items);
        // console.log("allHaikuboxes", allHaikuboxes);
        // console.log("nextToken", nextToken);
      } while (nextToken != null);
      // console.log("Devices", this.devices);
      var nameList = [];
      allHaikuboxes.forEach(function (element) {
        // console.log(element.owner);
        //if ((element.owner != null) & tempList.includes(element.serial)) {
        if (element.owner != null) {
          if (userIds.includes(element.owner) == false)
            userIds.push(element.owner); //remove duplicates
          if (element.name != null)
            nameList.push(element.serial + ": " + element.name);
          else {
            nameList.push(element.serial);
          }
        }
      });
      this.haikuboxList = nameList;
      this.userIdList = userIds;
      //console.log("Haikubox list", this.haikuboxList);
    },
    async getDevicesByOwner() {
      // console.log("getDevicesByOwner", this.email);
      const userInfo = await API.graphql({
        query: haikuboxUserByEmail,
        variables: { email: this.email },
      });
      this.userID = userInfo.data.haikuboxUserByEmail.items[0].id;
      // console.log("getDevicesByOwner", userInfo.data.haikuboxUserByEmail.items[0]);
      this.confirmedEmail =
        userInfo.data.haikuboxUserByEmail.items[0].confirmedEmail;
      this.accountUpdatedAt = moment
        .utc(userInfo.data.haikuboxUserByEmail.items[0].updatedAt)
        .tz("America/New_York")
        .format("dddd, MMMM Do YYYY, h:mm:ss a");

      const devicesByOwner = await API.graphql({
        query: haikuboxByOwner,
        variables: { owner: this.userID },
      });
      var ownerList = devicesByOwner.data.haikuboxByOwner.items;
      //console.log("devicesByOwner", ownerList);
      var nameList = [];
      this.haikuboxProps = ownerList;
      ownerList.forEach(function (element) {
        // console.log(element.owner);
        //if ((element.owner != null) & tempList.includes(element.serial)) {
        if (element.owner != null) {
          if (element.name != null) {
            nameList.push(element.serial + ": " + element.name);
          } else {
            nameList.push(element.serial);
          }
        }
      });
      this.haikuboxList = nameList;
      this.numHaikuboxes = nameList.length;

      const oneSignalConsent = await API.graphql({
        query: getOneSignalConsent,
        variables: { id: this.userID },
      });
      // console.log("oneSignalConsent", oneSignalConsent);
      try {
        if (
          oneSignalConsent.data.getOneSignalConsent.osConsentGranted == true
        ) {
          this.oneSignalConsentGranted = true;
        } else {
          this.oneSignalConsentGranted = false;
        }
      } catch {
        this.oneSignalConsentGranted = false;
      }
      this.getSubscriptionStatus();
    },
    async getSubscriptionStatus() {
      // query subscription state
      var subscriptionStates = [];
      for (const item of this.haikuboxProps) {
        // console.log(item);
        const subscriptionStatus = await API.graphql({
          query: getSubscription,
          variables: { id: item.serial },
        });
        // console.log(subscriptionStatus.data.getSubscription);
        subscriptionStatus.data.getSubscription.prepaidPeriodEndUnix = moment
          .unix(subscriptionStatus.data.getSubscription.prepaidPeriodEndUnix)
          .format("YYYY-MM-DD HH:mm:ss");
        if (
          subscriptionStatus.data.getSubscription.stripeCurrentPeriodEndUnix !=
          null
        ) {
          subscriptionStatus.data.getSubscription.stripeCurrentPeriodEndUnix =
            moment
              .unix(
                subscriptionStatus.data.getSubscription
                  .stripeCurrentPeriodEndUnix
              )
              .format("YYYY-MM-DD HH:mm:ss");
        }
        subscriptionStates.push(subscriptionStatus.data.getSubscription);
      }
      this.subscriptionProps = subscriptionStates;
    },
    async selectHaikubox(serialName) {
      const id = serialName.split(":");
      let serialClicked = id[0];
      const haikuboxId = serialClicked.split("_");
      // console.log("selectHaikubox", serialClicked);
      // get owner
      const deviceInfo = await API.graphql({
        query: getDevice,
        variables: {
          id: haikuboxId[1],
        },
      });
      // console.log('deviceInfo', deviceInfo);
      // get email associated with Haikubox
      const userInfo = await API.graphql({
        query: getHaikuboxUser,
        variables: {
          id: deviceInfo.data.getDevice.owner,
        },
      });
      // console.log('email lookup', userInfo);
      this.email = userInfo.data.getHaikuboxUser.email;

      await this.getState(serialClicked);
      this.getBootTable(serialClicked);
      this.getStatus(serialClicked);
      this.getDevicesByOwner(); // load all Haikuboxes for this owner which also gets other info about the Haikubox
      this.getHits(serialClicked);
    },
    async getHits(serialClicked) {
      // console.log("getHits", serialClicked);
      this.currentSerial = serialClicked;
      var nextToken = null;
      let yesterdayDate;
      var tempHits = [];

      if (this.recentHours > 0) {
        yesterdayDate = moment
          .utc()
          .subtract(this.recentHours, "hours")
          .format();
        // console.log(yesterdayDate)
        do {
          const queryHits = await API.graphql({
            query: hitBySerialByDate,
            variables: {
              serial: serialClicked,
              dt: { gt: yesterdayDate },
              sortDirection: "DESC",
              nextToken: nextToken,
            },
            filter: { wav: { gt: "" } },
          });
          tempHits = tempHits.concat(queryHits.data.hitBySerialByDate.items);
          nextToken = queryHits.data.hitBySerialByDate.nextToken;
          this.hitsLoading = tempHits.length;
        } while (nextToken != null);
      }
      if (this.recentHours == 0) {
        let startDate = moment(this.hitDatePicker)
          .tz(this.currentTimezone)
          .utc()
          .format("YYYY-MM-DDTHH:mm:ss");
        let endDate = moment(startDate)
          .add(24, "hours")
          .format("YYYY-MM-DDTHH:mm:ss");
        // console.log('query hits ', startDate, endDate)
        do {
          const queryHits = await API.graphql({
            query: hitBySerialByDate,
            variables: {
              serial: serialClicked,
              dt: { between: [startDate, endDate] },
              sortDirection: "DESC",
              nextToken: nextToken,
            },
            filter: { wav: { gt: "" } },
          });
          tempHits = tempHits.concat(queryHits.data.hitBySerialByDate.items);
          nextToken = queryHits.data.hitBySerialByDate.nextToken;
          this.hitsLoading = tempHits.length;
        } while (nextToken != null);
      }
      // keep track of species in list and put wav files in list
      var speciesHits = [];
      var uniqueHits = [];
      var speciesDict = {};
      var counter = 0;

      for (var i = 0; i < tempHits.length; i++) {
        // var splitWav = tempHits2[i]["wav"].split("_");
        //var wavTimeStamp = splitWav[3].slice(0, -5);
        var wavTimeStamp = tempHits[i].dt;
        // console.log(wavTimeStamp, this.currentTimezone)
        // let wavTimeMoment = moment(wavTimeStamp).fromNow();
        var wavTimeMoment = moment
          .utc(wavTimeStamp)
          .tz(this.currentTimezone)
          .locale(this.selectedLanguage)
          .format('ll LTS');

        // console.log(splitWav, wavTimeStamp);
        // console.log(wavTimeMoment);

        // use for quick check of low scores
        // var listname = "L " + tempHits2[i].score) + ' ' + wavTimeMoment;
        var listname = "L " + wavTimeMoment;
        if ((tempHits[i].score > 0.4) & (tempHits[i].specSum > 2)) {
          listname = "M " + wavTimeMoment;
        }
        if (tempHits[i].score > 0.9 && tempHits[i].specSum > 6) {
          listname = "H " + wavTimeMoment;
        }

        if (
          tempHits[i].score > 0.4 &&
          tempHits[i].specSum > 3 &&
          tempHits[i].version.slice(-1) == "D"
        ) {
          listname = "M. " + wavTimeMoment;
        }
        if (
          tempHits[i].score > 0.9 &&
          tempHits[i].specSum > 5 &&
          tempHits[i].version.slice(-1) == "D"
        ) {
          listname = "H. " + wavTimeMoment;
        }

        if (!speciesHits.includes(tempHits[i].cn)) {
          speciesHits.push(tempHits[i].cn);
          speciesDict[tempHits[i].cn] = counter;
          uniqueHits.push(tempHits[i]);
          uniqueHits[counter].wavList = [
            {
              filename: tempHits[i]["wav"],
              listname: listname,
              dt: tempHits[i]["dt"],
              score: tempHits[i]["score"],
              specSum: tempHits[i]["specSum"],
            },
          ];
          uniqueHits[counter].currentWav = {
            filename: tempHits[i]["wav"],
            listname: listname,
            dt: tempHits[i]["dt"],
            score: tempHits[i]["score"],
            specSum: tempHits[i]["specSum"],
          };
          uniqueHits[counter].playbackIndex = 0;
          uniqueHits[counter].window = "image";
          uniqueHits[counter].showBird = true;
          uniqueHits[counter].notifyBird = false;
          counter = counter + 1;
        } else {
          uniqueHits[speciesDict[tempHits[i].cn]]["wavList"].push({
            filename: tempHits[i]["wav"],
            listname: listname,
            dt: tempHits[i]["dt"],
            score: tempHits[i]["score"],
            specSum: tempHits[i]["specSum"],
          });
        }
      }
      // console.log('speciesHits', speciesHits);
      // console.log('speciesDict', speciesDict);
      // console.log("uniqueHits", uniqueHits);

      // query hidden list for this Haikubox
      // query hideBirds condition for this Haikubox
      const returnCount = await API.graphql({
        query: hideBirdBySerial,
        variables: {
          serial: serialClicked,
        },
      });
      // console.log('hideBirdBySerial', returnCount.data.hideBirdBySerial.items);
      let hiddenBirdList = returnCount.data.hideBirdBySerial.items;
      let customHiddenList = [];
      for (let i = 0; i < hiddenBirdList.length; i++) {
        customHiddenList.push(hiddenBirdList[i].cn);
      }

      // query notify birds
      nextToken = null;
      let notifyBirdList = [];
      do {
        const notify = await API.graphql({
          query: notifyBirdBySerial,
          variables: {
            serial: serialClicked,
            nextToken: nextToken,
          },
        });
        notifyBirdList = notifyBirdList.concat(
          notify.data.notifyBirdBySerial.items
        );
        nextToken = notify.data.notifyBirdBySerial.nextToken;
      } while (nextToken != null);

      let customNotifyList = [];
      // console.log('notifyBirdList', notifyBirdList);
      for (let i = 0; i < notifyBirdList.length; i++) {
        customNotifyList.push(notifyBirdList[i].cn);
      }

      // update hits with notifyBird
      for (i in uniqueHits) {
        if (customNotifyList.includes(uniqueHits[i].cn)) {
          uniqueHits[i].notifyBird = true;
          // console.log("notify index and species", i, uniqueHits[i]);
        }
      }

      // // query favorites
      // for (i = uniqueHits.length - 1; i >= 0; i--) {
      //   uniqueHits[i].favoriteHit = false;
      //   // console.log(uniqueHits[i].currentWav.filename);
      //   const favoriteHit = await API.graphql({
      //     query: getFavoriteHit,
      //     variables: {
      //       id: uniqueHits[i].wav,
      //     },
      //   });
      //   if (favoriteHit.data.getFavoriteHit != null) {
      //     uniqueHits[i].favoriteHit = true;
      //     // console.log('getHits favorite', favoriteHit);
      //   }
      // }

      this.hits = uniqueHits; // this.hits is what is looped through to show cards
      // console.log("hits", this.hits);
      this.hitsLoading = 0; // hide hits loading counter
    },
    hitSelectDate() {
      // console.log('hitsSelectRange');
      if (this.hitCalendarDatePicked == false) {
        this.hitCalendarDatePicked = true; // hide calendar
      } else {
        this.hitCalendarDatePicked = false; // show calendar
        this.recentHours = 0;
      }
    },
    hitDateClick() {
      console.log('hitDateClick', this.hitDatePicker);
      this.hitCalendarDatePicked = true; // hide calendar
      this.changeRecentHours(0);
    },
    changeRecentHours(numHours) {
      this.hitCalendarDatePicked = true; // hide calendar
      this.recentHours = numHours;
      this.hits = [];
      this.hitsLoading = 0;
      this.getHits(this.currentSerial);
    },
    async getBootTable(serialClicked) {
      let lastMonth = moment.utc().subtract(345, "days").format();
      const filterArg = {
        serial: serialClicked,
        createdAt: { gt: lastMonth },
      };
      const bootTable = await API.graphql({
        query: bootBySerialByDate,
        variables: filterArg,
      });
      var bootData = bootTable.data.bootBySerialByDate.items;
      var tempBootTable = [];
      for (var index in bootData) {
        var datetimeX = moment
          .utc(bootData[index].createdAt)
          .tz(this.timezone)
          .format("dddd, MMMM Do YYYY, h:mm:ss a");
        tempBootTable[index] = bootData[index];
        tempBootTable[index].createdAt = datetimeX; // local time
      }
      this.bootTable = tempBootTable;
      // console.log("getBootTable", bootData);
      // if (bootData.length > 0) {
      //   this.firmwareVersion = bootData[bootData.length - 1].version;
      // } else {
      //   this.firmwareVersion = 0;
      // }
    },
    async getState(serialClicked) {
      const deviceState = await API.graphql({
        query: getDeviceState,
        variables: { id: serialClicked },
      });
      var clickedDevice = deviceState.data.getDeviceState;
      // console.log("getState", clickedDevice);
      if (clickedDevice.lat != null) {
        this.lat = clickedDevice.lat;
        this.lon = clickedDevice.lon;
      }
      if (clickedDevice.timezone != null) {
        this.timezone = clickedDevice.timezone.replace(/ /g, "_");
      } else {
        this.timezone = "America/New_York";
      }
      this.firmwareVersion = clickedDevice.version;
    },
    async getStatus(serialClicked) {
      let yesterdayDate = moment.utc().subtract(2, "days").format();
      var nextToken = null;
      var haikuboxStatus = [];

      do {
        const filterArg = {
          serial: serialClicked,
          createdAt: { gt: yesterdayDate },
          nextToken: nextToken,
        };
        const boxStatus = await API.graphql({
          query: statusByDate,
          variables: filterArg,
        });
        haikuboxStatus = haikuboxStatus.concat(
          boxStatus.data.statusByDate.items
        );
        nextToken = boxStatus.data.statusByDate.nextToken;
      } while (nextToken != null);

      // check if any loaded, if not try to go back in time farther
      if (haikuboxStatus.length == 0) {
        yesterdayDate = moment.utc().subtract(30, "days").format();
        nextToken = null;
        haikuboxStatus = [];

        do {
          const filterArg = {
            serial: serialClicked,
            createdAt: { gt: yesterdayDate },
            nextToken: nextToken,
          };
          const boxStatus = await API.graphql({
            query: statusByDate,
            variables: filterArg,
          });
          haikuboxStatus = haikuboxStatus.concat(
            boxStatus.data.statusByDate.items
          );
          nextToken = boxStatus.data.statusByDate.nextToken;
        } while (nextToken != null);
      }

      // check if any loaded, if not try to go back in time farther
      if (haikuboxStatus.length == 0) {
        yesterdayDate = moment.utc().subtract(180, "days").format();
        nextToken = null;
        haikuboxStatus = [];

        do {
          const filterArg = {
            serial: serialClicked,
            createdAt: { gt: yesterdayDate },
            nextToken: nextToken,
          };
          const boxStatus = await API.graphql({
            query: statusByDate,
            variables: filterArg,
          });
          haikuboxStatus = haikuboxStatus.concat(
            boxStatus.data.statusByDate.items
          );
          nextToken = boxStatus.data.statusByDate.nextToken;
        } while (nextToken != null);
      }

      // console.log(haikuboxStatus);
      // console.log("getStatus", serialClicked, yesterdayDate, haikuboxStatus);
      var cpuTempSeries = [];
      var cpuFreqSeries = [];
      var ramdiskSeries = [];
      var signalSeries = [];
      var nDirectSeries = [];
      var nCloudSeries = [];
      var freeGbSeries = [];
      var vSeries = [];
      var ovfSeries = [];
      var postTimeSeries = [];


      var currentWiFi = 0;

      for (var entry in haikuboxStatus) {
        var datetimeX = moment
          .utc(haikuboxStatus[entry].createdAt)
          .tz(this.timezone)
          .format("MM-DD hh:mm a");
        cpuTempSeries.push([datetimeX, haikuboxStatus[entry].cpuTemp]);
        cpuFreqSeries.push([datetimeX, haikuboxStatus[entry].cpuFreq]);
        ramdiskSeries.push([datetimeX, haikuboxStatus[entry].ramdisk]);
        signalSeries.push([datetimeX, haikuboxStatus[entry].signal]);

        nDirectSeries.push([datetimeX, haikuboxStatus[entry].nDirect]);

        nCloudSeries.push([datetimeX, haikuboxStatus[entry].nCloud]);

        if (haikuboxStatus[entry].freeGB != null && haikuboxStatus[entry].freeGB !== undefined) {
          freeGbSeries.push([datetimeX, haikuboxStatus[entry].freeGB]);
        }
        if (haikuboxStatus[entry].V != null && haikuboxStatus[entry].V !== undefined) {
          vSeries.push([datetimeX, haikuboxStatus[entry].V]);
        }

        if (haikuboxStatus[entry].ovf != null && haikuboxStatus[entry].ovf !== undefined) {
          ovfSeries.push([datetimeX, haikuboxStatus[entry].ovf]);
        }

        if (haikuboxStatus[entry].postTime != null && haikuboxStatus[entry].postTime !== undefined) {
          postTimeSeries.push([datetimeX, haikuboxStatus[entry].postTime]);
        }

        currentWiFi = haikuboxStatus[entry].signal;
      }
      this.cpuTempSeries = cpuTempSeries;
      this.cpuFreqSeries = cpuFreqSeries;
      this.ramdiskSeries = ramdiskSeries;
      this.signalSeries = signalSeries;
      this.nDirectSeries = nDirectSeries;
      this.nCloudSeries = nCloudSeries;
      this.freeGbSeries = freeGbSeries;
      this.vSeries = vSeries;
      this.ovfSeries = ovfSeries;
      this.postTimeSeries = postTimeSeries;
      this.currentWiFi = currentWiFi;
    },
    async getNotice() {
      const noticeInfo = await API.graphql({
        query: getNoticeDescription,
        variables: { id: this.noticeId },
      });
      this.noticeDescription = noticeInfo.data.getNoticeDescription;
      // console.log("getNotice", this.noticeDescription);
    },
    async getDeviceHistory() {
      this.deviceHistory = [];
      for (var i = 7; i >= 0; i--) {
        let currentDate = moment.utc().subtract(i, "days").format("YYYY-MM-DD");
        // console.log(currentDate);
        const deviceHistory = await API.graphql({
          query: deviceHistoryByDate,
          variables: { createDate: currentDate },
        });
        this.deviceHistory = this.deviceHistory.concat(
          deviceHistory.data.deviceHistoryByDate.items
        );
      }
      // console.log("getDeviceHistory", this.deviceHistory);
    },
    handleHistoryClick(value) {
      // console.log(value);
      this.haikubox = value.serial + ": " + value.name;
      this.selectHaikubox(value.serial);
    },
    refreshDeviceHistory() {
      this.getDeviceHistory();
    },
    async getMapCountsPerSpecies(commonName) {
      let yesterdayDate = moment
        .utc()
        .local()
        .subtract(24, "hours")
        .format("YYYY-MM-DD");
      var tempHits = [];
      var nextToken = null;
      do {
        const queryHits = await API.graphql({
          query: dailyCountSummaryByDateBySpecies,
          variables: {
            cn: { eq: commonName },
            countDate: yesterdayDate,
            nextToken: nextToken,
          },
        });
        tempHits = tempHits.concat(
          queryHits.data.dailyCountSummaryByDateBySpecies.items
        );
        nextToken = queryHits.data.dailyCountSummaryByDateBySpecies.nextToken;
      } while (nextToken != null);
      // console.log("getMapCountsPerSpecies tempHits", tempHits);
      var mapHits = [];
      for (let i = 0; i < tempHits.length; i++) {
        let mapCount = {
          lat: tempHits[i].lat,
          lon: tempHits[i].lon,
          radius: tempHits[i].countsPerDay * 100,
        };
        mapHits.push(mapCount);
      }
      return mapHits;
    },
    float2int(value) {
      return value | 0;
    },
    async setWindowRecent(index, value, spCode, commonName) {
      
      if (value == "daily") {
        this.hits[index].hourlyCountPlotData = await this.getHourlySpecies(
          commonName
        );
      }
      if (value == "monthly") {
        this.hits[index].dailyCountPlotData =
          await this.getDailySpeciesChartsJS(commonName);
      }
      if (value == "heatmap") {
        this.hits[index].heatmap = await this.getHeatmap(commonName);
      }
      if (value == "map") {
        this.hits[index].map = await this.getMapCountsPerSpecies(commonName);
      }
      this.hits[index].window = value;
      this.$forceUpdate();
      // this.hits[index].id += 1; // increment ID so that component updates
      // console.log("setWindowRecent", commonName, this.hits[index]);
    },
    async setWindowAll(index, value, spCode, commonName) {

      // console.log("setWindowAll", index, value, commonName);
      if (this.seriesDaily[index].window == value)
        this.seriesDaily[index].window = "none";
      // toggle view
      else {
        if (value == "monthly") {
          this.seriesDaily[index].dataSource.data =
            await this.getDailyCountsBySpecies(commonName);
        }
        this.seriesDaily[index].window = value;
      }
      this.seriesDaily[index].id += 1; // increment ID so that component updates
      // console.log("setWindowAll", this.seriesDaily[index]);
    },
    setWindowNew(index, value) {
      this.newSpeciesList[index].window = value;
      this.newSpeciesList[index].id += 1; // increment ID so that component updates
      // console.log("Change Window", this.hits[index]);
    },
    setWindowMissing(index, value) {
      this.missingSpeciesList[index].window = value;
      this.missingSpeciesList[index].id += 1; // increment ID so that component updates
      // console.log("Change Window", this.hits[index]);
    },
    async labelHit(index, item) {
      // console.log("labelHit", index, item);
      if (!item.classLabel) return;

      // copy file to label bucket
      await Storage.copy(
        { key: item.wav, level: "public" },
        { key: "label/" + item.wav, level: "private" }
      );

      if (item.classLabel == "No it's a ...") {
        this.hits[index].showEntryBox = true;
        this.hits[index].showSubmitBox = true;
        this.hits[index].id += 1; // increment ID so that component updates
        // console.log("no its a");
        return;
      }

      const serial = item.serial;
      const dt = item.currentWav["dt"];
      const group = item.group;
      const cn = item.cn;
      const sn = item.sn;
      const spCode = item.spCode;
      const wav = item.currentWav["filename"];
      const labeledBy = this.user;
      const label = item.classLabel;
      const score = item.currentWav["score"];
      const lat = item.lat;
      const lon = item.lon;
      const labeledData = {
        serial,
        dt,
        group,
        cn,
        sn,
        spCode,
        wav,
        labeledBy,
        label,
        score,
        lat,
        lon,
      };
      API.graphql({
        query: createLabeledData,
        variables: { input: labeledData },
      });

      // console.log(labeledData);

      if (
        (item.classLabel == "No") |
        (item.classLabel == "Yes")
      ) {
        this.hits[index].showEntryBox = false;
        this.hits[index].id += 1; // increment ID so that component updates
      }
    },
    labelHitCustom(index, item) {
      // console.log("labelHitCustom");
      if (!item.classLabel) return;
      const serial = item.serial;
      const dt = item.dt;
      const group = item.group;
      const cn = item.cn;
      const sn = item.sn;
      const spCode = item.spCode;
      const wav = item.wav;
      const labeledBy = this.user;
      const label = item.tellUsMore;
      const score = item.score;
      const lat = item.lat;
      const lon = item.lon;
      const labeledData = {
        serial,
        dt,
        group,
        cn,
        sn,
        spCode,
        wav,
        labeledBy,
        label,
        score,
        lat,
        lon,
      };
      API.graphql({
        query: createLabeledData,
        variables: { input: labeledData },
      });
      this.hits[index].submitted = true;
      this.hits[index].showSubmitBox = false;
      this.hits[index].id += 1; // increment ID so that component updates
    },
    // async addDeviceOwnersToNotice(){
    //   for (var i = 0; i<this.userIdList.length; i++){
    //     console.log(this.userIdList[i]);
    //     var id = this.noticeId + '-' + this.userIdList[i];
    //     var owner = this.userIdList[i];
    //     var noticeID = this.noticeId;
    //     var noticeViewed = "False";

    //     const noticeData = {
    //       id,
    //       owner,
    //       noticeID,
    //       noticeViewed
    //     };

    //     await API.graphql({
    //       query: createUserNotice,
    //       variables: {  input: noticeData },
    //     });
    //   }

    // },
  },
};
</script>
